module.exports = __webpack_public_path__ + "static/02-3352f746c02a485429eaf30ca5939015.jpg";